import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    activePaths: Array
  }

  connect() {
    const currentFullPath = window.location.pathname + window.location.search

    const isMatching = this.activePathsValue.some(path => {
      return currentFullPath.startsWith(path)
    })

    if (isMatching) {
      const target = this.element.querySelector(".collapse")
      if (target && !target.classList.contains("show")) {
        target.classList.add("show")
      }

      const toggleLink = this.element.querySelector('[data-toggle="collapse"]')
      if (toggleLink) {
        toggleLink.setAttribute("aria-expanded", "true")
      }

      const sidebarEls = ["navbar-left", "navCenter", "publish-container", "publish-table"]
      sidebarEls.forEach(id => {
        const el = document.getElementById(id)
        if (el && !el.classList.contains("nav-expanded")) {
          el.classList.add("nav-expanded")
        }
      })
    }
  }
}